<template>
  <div class="search">
      <div class="search_box">
        <input type="text"
        v-model="searchData"
        @keyup.enter="searchSubmit" placeholder="搜索">
        <div class="search_icon" @click="searchSubmit" ></div>
      </div>
  </div>
</template>
<script>

  export default {
    name: "headers",
    data() {
          return {
              searchData:this.searchValue
          }
    },
    props: {
        searchValue: {
          type: String,
          default: ""
        },
    },
    methods: {
      searchSubmit(){
        if(this.$route.query.id!=this.searchData){
          this.$emit("searchVal",this.searchData);
        }
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
h1, h2 {
  font-weight: normal;
}
.header {
  height: 32px;
  padding:9px 16px 10px;
  background: #FFFFFF;
  min-width: 1200px;
  box-shadow: 0 2px 14px -4px rgba(37,37,46,0.20);
}
.logo{
  float: left;
  padding:4px 0 2px;
  height:25px;
  vertical-align: top;
}
.hr101{
  display: block;
  overflow: hidden;
  float: left;
  height:25px;
  margin-right:16px;
  img{
    width: 96px;
    height:25px;
    display: block;
  }
}
.help_logo{
  // padding:3px 0 2px;
  display: inline-block;
  vertical-align: top;
  height:26px;
  line-height: 26px;
  font-family: PingFangSC-Regular;
  font-size: 18px;
  color: #202428;
  letter-spacing: 0;
  line-height: 26px;
}
.search_header{
  float: right;
}
 .articles_search .search_box{
    margin-top:-2px;
  }
.search_box{
    // margin-top:40px;
    width: 180px;
    height:30px;
    margin:0px auto;
    background: #FFFFFF;
    background: #FFFFFF;
    border: 1px solid #D2D3D4;
    border-radius: 2px;
    position: relative;
    z-index:3;
    input::-webkit-input-placeholder{
      font-family: PingFangSC-Regular;
      font-size: 13px;
      color: #AAACAD;
      line-height: normal;
      line-height: 20px\9;
    }
    input{
      height:20px;
      width: 136px;
      font-size: 13px;
      color: #515457;
      padding:5px 0px 5px 12px;
      line-height: 20px;
      border-top-left-radius: 26px;
      border-bottom-left-radius: 26px;
      border:none;
      background: none;
      outline: none;
      float: left;
      font-family: PingFangSC-Regular;
    }
    .search_icon{
      position: absolute;
      right:0px;
      top:0px;
      z-index: 4;
      width: 16px;
      height: 16px;
      padding:8px 8px 8px;
      background: url("./../assets/icon-xiaosousuo.png") no-repeat 7px 7px;
      background-size: 16px 16px;
      cursor: pointer;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/search.vue